import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class AtualizacaoEventoService extends BaseService {
  constructor() {
    super(`${ConfigApi.atualizacaoEventoURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.numeroContrato = undefined;
    this.versao = '';
    this.evento = '';
    this.limit = 50;
    this.page = 0;
  }
}
export default new AtualizacaoEventoService();
